import { StoreListing } from '@portals/api/partners';
import { PeriodEnum } from '@portals/types';

import { PaymentSettingsType } from '../../types/store-listings.types';

export enum StepId {
  ChooseProduct = 'chooseProduct',
  PaymentSettings = 'paymentSettings',
}

export interface StoreListingWizardContext {
  intent: 'create' | 'edit' | 'publish';
  storeListing: StoreListing | undefined;
  selectedProduct: StoreListing['product'] | undefined;
  paymentSettings: Partial<PaymentSettingsType>;
  paymentSettingsAccordionValues: Array<PeriodEnum>;
  paymentSettingsGeneralError: string | undefined;
}

export type OnCloseCallback = (params: { confirmBeforeClose: boolean }) => void;
